import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {host} from '../../function/api'

export const editSectionTwo = createAsyncThunk(
    'editSectionTwo',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                _method: 'PATCH',
                url: `${host}sectionTwo/${data.id}`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
        })

            return response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const sectionIndex = createAsyncThunk(
    'section/index',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}sectionTwo?section=${data.section}&page=${data.pageNumber}&per_page=${data.countPerPage}&search=${data.search}&delay=1`,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
        })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const sectionStore = createAsyncThunk(
    'section/store',
    async(data, thunkApi) => {
        try {
            const response = await axios.post(
                `${host}sectionTwo`,
                data,{
                    headers: {
                        'Accept': 'Application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }        
                })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

const initialState= {
    archiveSectionTwoLoading: false,
    archiveSectionTwoSuccess: false,
    sections: [],
    errorSection: '',
    errorTitle: '',
    message: '',
    CreateSectionTwo: '',
    error: ''
}

const sectionTwoSlice = createSlice({
    name: 'sectionTwo',
    initialState,
    reducers: {

    },
    extraReducers: {
        [editSectionTwo.fulfilled]: (state, {payload}) => {  
            state.archiveSectionTwoLoading = false
            state.archiveSectionTwoSuccess = true
            state.message = payload.message
            state.errorTitle = ""
            state.errorArchive = ""
        },
        [editSectionTwo.pending] : (state) => {
            state.archiveSectionTwoLoading = true    
            state.archiveSectionTwoSuccess = false
        },
        [editSectionTwo.rejected]: (state, {payload}) => {
            state.archiveSectionTwoLoading = false
            state.archiveSectionTwoSuccess = false
            if(payload.response.data.error) {
                state.errorTitle = payload.response.data.error.title
                state.errorArchives = payload.response.data.error.store_id
            }
            if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
            
        },
        [sectionStore.fulfilled]: (state, {payload}) => {
            state.archiveSectionTwoLoading = false
            state.archiveSectionTwoSuccess = true
            state.CreateSectionTwo = payload.message
            state.errorTitle = ""
            state.errorSection = ""
            state.message = ""
        },
        [sectionStore.pending] : (state) => {
            state.archiveSectionTwoLoading = true    
            state.archiveSectionTwoSuccess = false
            state.CreateSectionTwo = ""
            state.message = ""
        },
        [sectionStore.rejected]: (state, {payload}) => {
            state.archiveSectionTwoLoading = false
            state.archiveSectionTwoSuccess = false
            state.CreateSectionTwo = payload.response.data.message
            state.message = ""
            
        },
        [sectionIndex.fulfilled]: (state, action) => {
            state.archiveSectionTwoLoading = false
            state.sections = action.payload.data
            state.previous = action.payload.previous
            state.rahpardaznetLoading = false;
            state.errorTitle = ""
            state.errorSection = ""
            state.CreateSectionTwo = ""
            state.message = ""
        },
        [sectionIndex.pending]: (state) => {
            state.archiveSectionTwoLoading = true
            state.rahpardaznetLoading = true;
            state.CreateSectionTwo = ""
            state.message = ""
        },
        [sectionIndex.rejected]: (state, {payload}) => {
            state.archiveSectionTwoLoading = false;
            state.archiveSectionTwoSuccess = false
            state.rahpardaznetLoading = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }else{
                state.message = ""
            }
            state.CreateSectionTwo = ""
        }
    }
})

export const {} = sectionTwoSlice.actions;
export default sectionTwoSlice.reducer; 